import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ImageModule } from '@df/module-image/image.module';
import { PriceComponent } from '@df/ui/price/price.component';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { AbstractFinanceFromComponent } from './abstract-v12-retail-finance-from.component';

@Component({
    selector: 'v12-retail-finance-from',
    templateUrl: 'v12-retail-finance-from.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [ICmsClientModule, PriceComponent, TranslationModule, ImageModule]
})
export class FinanceFromComponent extends AbstractFinanceFromComponent {
    @Input()
    isDiningChair = false;
}
